import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'
import { store } from './redux/store'

import App from './App'
import { GlobalStyles } from './styles'

ReactDOM.render(
   <React.StrictMode>
      <BrowserRouter>
         <Provider store={ store }>
            <App/>
            <GlobalStyles/>
         </Provider>
      </BrowserRouter>
   </React.StrictMode>,
   document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
